import { Options } from "@splidejs/splide";
import { initSplideCarousel } from "../../util/carousel";

const settings: Options = {
  mediaQuery: 'min',
  default: {
    type: "loop",
    arrows: true,
    pagination: true,
  },
  breakpoints: {
    768: {
      drag: false,
      perMove: 1,
    },
  }
}

function init() {
  const sliders = document.querySelectorAll(".js-fullwidth-carousel") as NodeListOf<HTMLElement>;

  for (const slider of sliders) {
    initSplideCarousel(slider, settings);
  }
}

export default init;
